import axios from '@fs/zion-axios'
import { getUser, clearCachedUser } from '@fs/zion-user'
import throwCisError from './throwCisError'

const axiosConfig = {
  headers: {
    accept: 'application/familysearch-identity-result+v4.2+json',
    'content-type': 'application/familysearch-identity-result+v4.2+json',
  },
}

const monthAbbrs = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function toCisDate({ day, month, year }) {
  return `${day} ${monthAbbrs[+month - 1]} ${year}`
}

export default async function updateBirthDate(cisDate) {
  const { cisId } = await getUser()
  try {
    await axios.post(
      '/service/ident/cis/cis-public-api/v4/user',
      { users: [{ id: cisId, type: 'userAccount', birthDate: cisDate }] },
      axiosConfig
    )
    clearCachedUser()
  } catch (error) {
    throwCisError(error)
  }
}
